import { DefaultSeo } from 'next-seo'
import { appWithTranslation } from 'next-i18next'

import { wrapper } from '../redux/store'

import '../styles/styles.css'
import '../styles/normalize.css'
import '../styles/concept.css'
import 'maplibre-gl/dist/maplibre-gl.css'
import 'react-spring-bottom-sheet/dist/style.css'

function App({ Component, pageProps }) {
  return (
    <>
      <DefaultSeo
        defaultTitle="Tracking | Captain.ai"
        titleTemplate="%s | Tracking | Captain.ai"
      />
      <Component {...pageProps} />
    </>
  )
}

export default wrapper.withRedux(appWithTranslation(App))
// export default appWithTranslation(wrapper.withRedux(App, nextI18NextConfig));
